import { render, staticRenderFns } from "./InnerContent.vue?vue&type=template&id=38dacde4"
import script from "./InnerContent.vue?vue&type=script&lang=js"
export * from "./InnerContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports